import React from 'react';
import PropTypes from 'prop-types';
import Columns from './DataComponent__TableColumns';
import Export from './DataComponent__TableExport';
import actions from './DataComponent.actions';

// const images = {
//     settings: require('img/icons/settings.svg'),
//     print: require('img/icons/print.svg')
// };

const DataComponentSettings = ({
    settings = false,
    tableBodyTitle = '',
    settingKey = '',
    headerNames = {},
    sessionId = '',
    totalRows = 0,
    data = [],
    filters = {}
}) => {
    const renderSettings = () => {
        if (!settings) return null;

        return (
            <React.Fragment>
                <div className={`settingsBar ${tableBodyTitle ? 'settingsBar--withTitle' : ''}`}>
                    <div>
                        <Columns
                            settingKey={settingKey}
                            data={headerNames}
                            onApply={actions.saveServerStorage}
                        />
                    </div>
                    <div>
                        <Export
                            settingKey={settingKey}
                            disabled={!data.length}
                            filter={filters}
                            sessionId={sessionId}
                            totalRows={totalRows}
                        />
                    </div>
                </div>
            </React.Fragment>
        );
    };

    return renderSettings();
};

DataComponentSettings.propTypes = {
    settings: PropTypes.bool,
    tableBodyTitle: PropTypes.string,
    settingKey: PropTypes.string,
    headerNames: PropTypes.object,
    sessionId: PropTypes.string,
    totalRows: PropTypes.number,
    data: PropTypes.array,
    filters: PropTypes.object,
    loading: PropTypes.bool
};

DataComponentSettings.defaultProps = {
    settings: false,
    tableBodyTitle: '',
    settingKey: '',
    headerNames: {},
    sessionId: '',
    totalRows: 0,
    data: [],
    filters: {},
    loading: false
};

export default DataComponentSettings;
